import React from 'react'
import '../stylesheets/language.sass'
import german from '../img/german.png'
import english from '../img/english.png'
import Content from '../StaticContent.json'

class LanguagePage extends React.Component {

	constructor (props) {
		super(props)
		this.props = props
		this.state = {language: props.language === undefined ? "de" : props.language}

		// Bind Functions to class
		this.confirmLanguage = this.confirmLanguage.bind(this)
		this.setLanguageByEvent = this.setLanguageByEvent.bind(this)
		this.setLanguage = this.setLanguage.bind(this)
		this.shuffleLanguage = this.shuffleLanguage.bind(this)
	}

	componentDidMount () {
		this.shuffler = setInterval(this.shuffleLanguage,5000)
	}

	componentWillUnmount() {
		clearInterval(this.shuffler)
	}

	render () {

		let content = this.state.language === "de" ? Content.de.languagepage : Content.en.languagepage

		return (<div className="languagePage">
					<header>
						<h1>{content[0]}</h1>
					</header>
					<div className="languageContainer">
						<div className="languageCard" id="de" onClick={this.confirmLanguage} onMouseEnter={this.setLanguageByEvent}>
							<img src={german} alt="" id="de" onClick={this.confirmLanguage} onMouseEnter={this.setLanguageByEvent}/>
							<h1 id="de" onClick={this.confirmLanguage} onMouseEnter={this.setLanguageByEvent}>Deutsch</h1>
						</div>
						<div className="languageCard" id="en" onClick={this.confirmLanguage} onMouseEnter={this.setLanguageByEvent}>
							<img src={english} alt="" id="en" onClick={this.confirmLanguage} onMouseEnter={this.setLanguageByEvent}/>
							<h1 id="en" onClick={this.confirmLanguage} onMouseEnter={this.setLanguageByEvent}>English</h1>
						</div>
					</div>
					<footer>
						<h2>{content[1]}</h2>
						<h2>{content[2]}</h2>
						<h3>{content[3]}</h3>
					</footer>
				</div>)
	}

	setLanguageByEvent (event) {
		this.setLanguage(event.target.id)
	}

	setLanguage (language) {
		this.setState({language: language})
		clearInterval(this.shuffler)
	}

	confirmLanguage (event) {
		this.props.setLanguage(event.target.id)
	}

	shuffleLanguage () {
		if (this.state.language === "de") {
			this.setState({language: "en"})
			return
		}
			this.setState({language: "de"})
	}

}
export default LanguagePage